import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EducationCourseListComponent } from './education-course-list.component';

@NgModule({
  imports: [CommonModule, EducationCourseListComponent],
  exports: [EducationCourseListComponent],
})
export class EducationCourseListModule {}
